import {createContext} from 'react';
import defaultConfig from 'src/internal/config/defaultConfig';

import type {DataConfig} from 'src/internal/config/types';

export default createContext<DataConfig>(defaultConfig);
